// Banner inner video: same pattern as fullcol-video – poster then inject video on load, fade to video. Supports multiple .banner-inner sections.

import { appendVimeoEmbed, createYoutubeEmbed } from "../utils/video-embeds.js";

const EMBED_CLASS = "banner-inner__video banner-inner__video--embed";

const injectVideo = (videoWrap) => {
  const videoType = (videoWrap.getAttribute("data-video-type") || "mp4").toLowerCase();
  const videoSrc = videoWrap.getAttribute("data-video-src") || "";
  const videoId = (videoWrap.getAttribute("data-video-id") || "").trim();

  if (videoType === "mp4" && videoSrc) {
    const el = document.createElement("video");
    el.className = "banner-inner__video";
    el.src = videoSrc;
    el.muted = true;
    el.loop = true;
    el.playsInline = true;
    el.setAttribute("playsinline", "");
    el.autoplay = true;
    videoWrap.appendChild(el);
    return el;
  }
  if (videoType === "youtube" && videoId) {
    return createYoutubeEmbed(videoWrap, videoId, EMBED_CLASS);
  }
  if (videoType === "vimeo" && videoId) {
    return appendVimeoEmbed(videoWrap, videoId, EMBED_CLASS);
  }
  return null;
};

const fadeToVideo = (posterEl, videoEl) => {
  const gsap = window.gsap;
  if (gsap) {
    gsap.set(videoEl, { opacity: 0 });
    gsap.to(posterEl, {
      opacity: 0,
      duration: 0.6,
      ease: "power2.out",
      onComplete: () => posterEl.remove(),
    });
    gsap.to(videoEl, { opacity: 1, duration: 0.6, ease: "power2.out", delay: 0.2 });
  } else {
    posterEl.style.transition = "opacity 0.6s ease";
    videoEl.style.transition = "opacity 0.6s ease";
    videoEl.style.opacity = "0";
    posterEl.style.opacity = "0";
    requestAnimationFrame(() => {
      videoEl.style.opacity = "1";
    });
    posterEl.addEventListener("transitionend", () => posterEl.remove(), { once: true });
  }
};

export const bannerInner = () => {
  const sections = document.querySelectorAll(".banner-inner");
  if (!sections.length) return;

  const pending = [];

  sections.forEach((section) => {
    const videoWrap = section.querySelector(".banner-inner__video-wrap");
    if (!videoWrap) return;

    const posterSrc = videoWrap.getAttribute("data-poster-src");
    const poster = document.createElement("img");
    poster.className = "banner-inner__poster";
    poster.src = posterSrc || "";
    poster.alt = "";
    poster.loading = "eager";
    videoWrap.appendChild(poster);

    pending.push({ videoWrap, poster });
  });

  const onLoad = () => {
    window.removeEventListener("load", onLoad);
    pending.forEach(({ videoWrap, poster }) => {
      Promise.resolve(injectVideo(videoWrap)).then((videoEl) => {
        if (videoEl) fadeToVideo(poster, videoEl);
      });
    });
  };

  if (document.readyState === "complete") {
    onLoad();
  } else {
    window.addEventListener("load", onLoad);
  }
};
